module.exports = __webpack_public_path__ + "img/send.f2c096c9.svg";